module.exports = __webpack_public_path__ + "static/media/Steven Roselle.900bec48.png";